import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { Company } from "../types";

export const editCompany = (payload: Partial<Company>) => {
  return apiClient<ApiResponse>("/v1/empresa", {
    method: "PUT",
    body: payload,
  });
};
